/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * One entry in the slim rail under the hero — a mode, a beta window, a season.
 * @export
 * @interface DropModeBody
 */
export interface DropModeBody {
    /**
     * 
     * @type {string}
     * @memberof DropModeBody
     */
    kicker: string;
    /**
     * 
     * @type {string}
     * @memberof DropModeBody
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof DropModeBody
     */
    meta?: string;
    /**
     * 
     * @type {string}
     * @memberof DropModeBody
     */
    href?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DropModeBody
     */
    upcoming?: boolean;
}

/**
 * Check if a given object implements the DropModeBody interface.
 */
export function instanceOfDropModeBody(value: object): value is DropModeBody {
    if (!('kicker' in value) || value['kicker'] === undefined) return false;
    if (!('title' in value) || value['title'] === undefined) return false;
    return true;
}

export function DropModeBodyFromJSON(json: any): DropModeBody {
    return DropModeBodyFromJSONTyped(json, false);
}

export function DropModeBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): DropModeBody {
    if (json == null) {
        return json;
    }
    return {
        
        'kicker': json['kicker'],
        'title': json['title'],
        'meta': json['meta'] == null ? undefined : json['meta'],
        'href': json['href'] == null ? undefined : json['href'],
        'upcoming': json['upcoming'] == null ? undefined : json['upcoming'],
    };
}

export function DropModeBodyToJSON(json: any): DropModeBody {
    return DropModeBodyToJSONTyped(json, false);
}

export function DropModeBodyToJSONTyped(value?: DropModeBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'kicker': value['kicker'],
        'title': value['title'],
        'meta': value['meta'],
        'href': value['href'],
        'upcoming': value['upcoming'],
    };
}

